// extracted by mini-css-extract-plugin
module.exports = {"di-modal-container":"FullScreenModal_di-modal-container__27PgC"};